import BaseClient from '@/app/model/api/response/baseApiClient'

class MachineDeleteApi extends BaseClient {
  public doMachineDelete (id: string) {
    const path: string = '/v1/machines/' + id

    /* 共通処理 */
    return super.doFetch(process.env.VUE_APP_API_URL + path, 'DELETE')
  }
}

export default new MachineDeleteApi()
